var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rubric-preview-container"},[(_vm.isAdvanced)?_c('AdvancedRubricPreviewTable',{attrs:{"criteria":_vm.criteria}}):_c('SimpleRubricPreviewTable',{attrs:{"criteria":_vm.criteria,"is-default":_vm.isDefault}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }